import React from 'react';
import { Phone } from 'lucide-react';

const WhatsAppButton = () => {
  const phoneNumber = '918602666456'; // Format: country code + number (no + or spaces)
  const message = encodeURIComponent('Hi, I would like to know more about your CA services.');
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 left-6 w-14 h-14 bg-gradient-to-br from-green-500 to-green-600 text-white rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-110 z-40 flex items-center justify-center group"
      aria-label="Contact on WhatsApp"
    >
      <Phone className="w-6 h-6" />
      <span className="absolute left-full ml-3 bg-gray-900 text-white text-sm px-3 py-1 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
        WhatsApp Us
      </span>
    </a>
  );
};

export default WhatsAppButton;
